
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.086 1.594A1 1 0 0111 1a4 4 0 014 4v3h4.655a3 3 0 012.994 3.45l-1.38 9A3.002 3.002 0 0118.275 23H4a3 3 0 01-3-3v-7a3 3 0 013-3h2.35l3.736-8.406zM8 11.212l3.608-8.117A2 2 0 0113 5v4a1 1 0 001 1h5.671a1 1 0 011 1.15l-1.38 9a1 1 0 01-1 .85H8v-9.788zM6 21v-9H4a1 1 0 00-1 1v7a1 1 0 001 1h2z","fill":"#04080E"}})])
          )
        }
      }
    